var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ai-residential-commercial',{attrs:{"enable-ai-search":_vm.enableAiSearch,"showResidential":_vm.showResidential,"showCommercial":_vm.showCommercial},on:{"AISearch":_vm.emitAISearch}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }